/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React from 'react';
import { Translation } from 'react-i18next';

import MaterialTable, { MaterialTableProps } from '@material-table/core';

import { CIColors } from 'shared';

import { tableIcons } from '../../constants/tableIcons';
import { Namespaces } from '../../i18n';

export type HUMaterialTableProps<RowData extends object> = MaterialTableProps<RowData> & object;

export class HUMaterialTable<RowData extends object> extends React.PureComponent<HUMaterialTableProps<RowData>> {
  render() {
    const { options = {}, components = {}, localization = {}, ...otherProps } = this.props;

    return (
      <Translation ns={Namespaces.Admin}>
        {t => (
          <MaterialTable
            components={{
              Container: props => (
                <div data-cy="material-table" style={{ width: '100%' }}>
                  {props.children}
                </div>
              ),
              ...components,
            }}
            icons={tableIcons}
            options={{
              maxColumnSort: 0,
              sorting: false,
              rowStyle: {
                color: CIColors.Text,
              },
              headerStyle: {
                minHeight: '52px',
                color: CIColors.Text,
                fontSize: '12px',
                lineHeight: '18px',
                textTransform: 'uppercase',
                borderWidth: '2px',
                wordBreak: 'keep-all',
              },
              actionsCellStyle: {
                minWidth: '58px',
              },
              pageSizeOptions: [10, 20, 50],
              pageSize: 10,
              ...options,
            }}
            localization={{
              ...(t('material_table', {
                returnObjects: true,
              }) || {}),
              ...localization,
            }}
            {...otherProps}
          />
        )}
      </Translation>
    );
  }
}

export const iconCellStyles: React.CSSProperties = {
  maxWidth: 130,
  textAlign: 'center',
};
